module.exports = __webpack_public_path__ + "static/media/techCoastSales.db529865.png";